import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutomaticDebitRemFile } from '../../models/automaticDebitRemFile';

@Component({
    selector: 'automatic-debit-select-dialog',
    templateUrl: './automatic-debit-select-dialog.component.html',
    styleUrls: ['./automatic-debit-select-dialog.component.scss'],
})
export class AutomaticDebitSelectDialogComponent implements OnInit {
    public fileSelected: AutomaticDebitRemFile = {} as AutomaticDebitRemFile;

    constructor(
        public dialogRef: MatDialogRef<AutomaticDebitSelectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.fileSelected = this.data.file;
        this.cdr.detectChanges();
    }

    closeModal() {
        this.dialogRef.close();
    }
}
